import React from 'react'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { Button, SH3 } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import AccountBlocked from '@zet/design-system/svg/AccountBlocked'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'
import { sendEmail } from '@zet/utils/sendEmail'

import { ErrorScreenLayout } from './components/errorScreenLayout'

const emailId =
  APP_NAME === MY_TEAMS_ADVISOR ? 'hi@myteams.in' : 'hi@onecode.in'

export const AccountBlockedScreen = () => {
  const onPress = () => {
    sendEmail(emailId)
  }

  return (
    <Stack>
      <ErrorScreenLayout
        ErrorIconComponent={AccountBlocked}
        title={i18n.t('errorScreens.accountBlocked')}
        description={i18n.t('errorScreens.accountBlockedDesc')}
        buttonTitle=""
        FooterComponent={() => (
          <Stack>
            <SH3 className="mb-4/2 text-grays-80">
              {i18n.t('errorScreens.writeToUs', { email: emailId })}
            </SH3>
            <Button onPress={onPress} fullWidth size="lg">
              {i18n.t('errorScreens.emailUs')}
            </Button>
          </Stack>
        )}
      />
    </Stack>
  )
}
